export default __webpack_public_path__ + "static/media/landing-page-image.a790c4cc.png";